export default __webpack_public_path__ + "static/media/reallyspeedlogo_2.c4aaf377.gif";